import { usePortfolioGames } from "@/hooks/usePortfolioGames";
import { About } from "./About";
import { Contact } from "./Contact";
import { ContactPage } from "./ContactPage";
import { Footer } from "./Footer";
import { Hero } from "./Hero";
import { Nav } from "./Nav";
import { ProjectsSection } from "./ProjectsSection";
import { ResumeModal } from "./ResumeModal";
import { Skills } from "./Skills";
import { Testimonials } from "./Testimonials";
import { Work } from "./Work";

export default function Portfolio() {
  const games = usePortfolioGames();

  return (
    <div className="min-h-screen bg-sand p-0 md:p-4">
      <div className="relative mx-auto max-w-[1440px] overflow-hidden rounded-[28px] border-3 border-ink bg-cream shadow-[0_0_0_3px_#141414]">
        <div
          className="absolute left-[38%] top-[-40px] z-[1] hidden h-[140px] w-[120px] animate-floatBlob rounded-[18px] border-3 border-ink bg-periwinkle shadow-[7px_7px_0_#141414] md:block"
          aria-hidden
        />

        <Nav unlockedCount={games.unlockedCount} />
        <Hero />
        <Skills />
        <About />
        <Work games={games} />
        <ProjectsSection games={games} />
        <Testimonials />
        <Contact onResumeClick={games.openResumeModal} />
        <Footer />

        <ResumeModal games={games} />
        <ContactPage games={games} />
      </div>
    </div>
  );
}
